import { useQuery } from '@tanstack/react-query';
import { StatCardGrid } from '@/components/common/StatCardGrid';
import { instituteSubmissionSummaryQueryOptions } from '../api/instituteSubmissions.api';
import { SUMMARY_CARDS } from '../constants/instituteSubmission.constants';
import type { InstituteSubmissionSummaryParams } from '../types/instituteSubmission.types';

interface InstituteSubmissionSummaryCardsProps {
  params: InstituteSubmissionSummaryParams;
}

export function InstituteSubmissionSummaryCards({ params }: InstituteSubmissionSummaryCardsProps) {
  const { data, isLoading, isError } = useQuery(instituteSubmissionSummaryQueryOptions(params));

  return (
    <StatCardGrid
      stats={SUMMARY_CARDS.map((card) => ({ ...card, value: data?.[card.key] }))}
      isLoading={isLoading}
      isError={isError}
    />
  );
}
